import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const SEO = ({ titleKey, descriptionKey, pagePath, type = 'website' }) => {
  const { t, i18n } = useTranslation('seo'); // Koristi tvoj novi seo.json namespace
  const currentLang = i18n.language;
  
  const location = useLocation();
  const siteTitle = 'PC CENTAR - Distribucija IT opreme';
  const baseUrl = 'https://pccentar.rs'; 

  // Izvlačimo prevode na osnovu ključeva koje prosledimo (npr. 'home.title')
  const seoTitle = t(titleKey);
  const seoDescription = t(descriptionKey);
  const fullTitle = `${seoTitle} | ${siteTitle}`;

  // Funkcija koja pravi ispravan URL za kanonske tagove i jezike
  const getFullUrl = (lang) => {
    const langPrefix = lang === 'sr' ? '' : `/${lang}`;
    // Čistimo URL od duplih kosa crta
    return `${baseUrl}${langPrefix}/${pagePath}`.replace(/\/$/, "");
  };

  const currentUrl = getFullUrl(currentLang);

  // CORPORATE SCHEMA - Ovo govori Google-u da ste prava firma
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Corporation",
    "name": "PC Centar",
    "url": "https://pccentar.rs",
    "logo": "https://pccentar.rs/logo.png", // Proveri da li imaš logo.png u public folderu
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Belgrade",
      "addressCountry": "RS"
    }
  };

  // SPA pageview tracking
  useEffect(() => {
    if (!window.gtag) return; // Ako skripta još nije učitana
    window.gtag('config', 'G-1MSRKZRT9B', {
      page_path: location.pathname,
    });
  }, [location.pathname]);
  
  return (
    <Helmet>
      <html lang={currentLang} />
      <title>{fullTitle}</title>
      <meta name="description" content={seoDescription} />
      <link rel="canonical" href={currentUrl} />

      {/* Hreflang - Ključno da Google ne pomeša SR i EN verziju */}
      <link rel="alternate" href={getFullUrl('sr')} hrefLang="sr" />
      <link rel="alternate" href={getFullUrl('en')} hrefLang="en" />
      <link rel="alternate" href={getFullUrl('sr')} hrefLang="x-default" />

      {/* Open Graph - Kako sajt izgleda na LinkedIn-u i Viberu */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={`${baseUrl}/og-corporate.jpg`} />

      {/* Ubacivanje Schema.org podataka */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

      {/* Google Analytics 4 */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-1MSRKZRT9B"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-1MSRKZRT9B'); // ovo je tvoj GA4 ID
        `}
      </script>
    </Helmet>
  );
};

export default SEO;